module.exports = __webpack_public_path__ + "static/media/protection_paper_getty_desktop.f92893c9.jpg";